const reportConfigLockResult = {
    success: 'Success',
    lockedByAnotherUser: 'LockedByAnotherUser',
    lockingNotAllowed: 'Locking Not Allowed'
};

export default reportConfigLockResult;